import { render, staticRenderFns } from "./team-form-new.vue?vue&type=template&id=67799803"
import script from "./team-form-new.vue?vue&type=script&lang=js"
export * from "./team-form-new.vue?vue&type=script&lang=js"
import style0 from "./team-form-new.vue?vue&type=style&index=0&id=67799803&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports